import { render, staticRenderFns } from "./reset_password.vue?vue&type=template&id=7a4bbe0a&scoped=true&"
import script from "./reset_password.vue?vue&type=script&lang=js&"
export * from "./reset_password.vue?vue&type=script&lang=js&"
import style0 from "./reset_password.vue?vue&type=style&index=0&id=7a4bbe0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4bbe0a",
  null
  
)

export default component.exports